















































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  BarisRegisterKebidanan,
  KolomRegisterKebidanan
} from "@/services/LaporanKebidanan";

interface SelHeader {
  id: string;
  key: string;
  label: string;
  colspan: number;
  rowspan: number;
  lengket: boolean;
}

const LEBAR_LENGKET: Record<string, number> = {
  no: 40,
  sigizikesga: 96,
  ruang: 110,
  cm: 72,
  nama: 170
};

const LEBAR_MIN: Record<string, number> = {
  suami: 140,
  nik: 130,
  alamat: 220,
  jaminan: 110,
  asal_masuk: 120,
  asal_rujukan: 140,
  transfusi: 130,
  dx_masuk: 200,
  tidak_lahir: 160,
  persalinan: 180,
  dx_keluar: 220,
  tindakan: 180,
  penyebab_kematian: 200,
  lain_lain: 120
};

@Component
export default class TabelRegisterKebidanan extends Vue {
  @Prop({ type: Array, required: true })
  readonly kolom!: KolomRegisterKebidanan[];
  @Prop({ type: Array, required: true })
  readonly rows!: BarisRegisterKebidanan[];
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;
  @Prop({ type: String, default: "Tidak ada pasien pada periode ini." })
  readonly teksKosong!: string;

  get kiriLengket(): Record<string, number> {
    const kiri: Record<string, number> = {};
    let x = 0;

    for (const k of this.kolom) {
      if (!(k.key in LEBAR_LENGKET)) break;
      kiri[k.key] = x;
      x += LEBAR_LENGKET[k.key];
    }

    return kiri;
  }

  get barisHeader(): SelHeader[][] {
    const n = this.kolom.reduce((m, k) => Math.max(m, k.jalur.length), 1);
    const baris: SelHeader[][] = [];

    for (let i = 0; i < n; i++) baris.push([]);

    for (const k of this.kolom) {
      const d = k.jalur.length;

      for (let i = 0; i < d; i++) {
        if (i < d - 1) {
          const id = "grup:" + k.jalur.slice(0, i + 1).join("/");
          const akhir = baris[i][baris[i].length - 1];

          if (akhir && akhir.id === id) {
            akhir.colspan++;
            continue;
          }

          baris[i].push({
            id,
            key: k.key,
            label: k.jalur[i],
            colspan: 1,
            rowspan: 1,
            lengket: false
          });
        } else {
          baris[i].push({
            id: "daun:" + k.key,
            key: k.key,
            label: k.jalur[i],
            colspan: 1,
            rowspan: n - i,
            lengket: this.lengket(k.key)
          });
        }
      }
    }

    return baris;
  }

  lengket(key: string): boolean {
    return key in this.kiriLengket;
  }

  gayaSel(key: string, lengket: boolean): Record<string, string> {
    const gaya: Record<string, string> = {};

    if (lengket) {
      gaya.left = `${this.kiriLengket[key]}px`;
      gaya.minWidth = `${LEBAR_LENGKET[key]}px`;
      gaya.maxWidth = `${LEBAR_LENGKET[key]}px`;
    } else if (key in LEBAR_MIN) {
      gaya.minWidth = `${LEBAR_MIN[key]}px`;
    }

    return gaya;
  }

  kelasSel(k: KolomRegisterKebidanan): Record<string, boolean> {
    return {
      lengket: this.lengket(k.key),
      tengah: k.cek || k.key === "no",
      teks: k.key in LEBAR_MIN
    };
  }
}
